import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL}/safety`;
const token = () => localStorage.getItem("token");
const headers = () => ({ headers: { Authorization: "Bearer " + token() } });

export const getMeta = () => axios.get(`${base}/meta`, headers());
export const getOverview = asOf =>
  axios.get(`${base}/overview${asOf ? `?asOf=${asOf}` : ""}`, headers());
export const getEmployeeSafety = id => axios.get(`${base}/employees/${id}`, headers());
export const getAlerts = () => axios.get(`${base}/alerts`, headers());
export const readAlerts = ids => axios.post(`${base}/alerts/read`, ids ? { ids } : {}, headers());

export const getTopics = () => axios.get(`${base}/topics`, headers());
export const addLibraryTopics = keys => axios.post(`${base}/topics/library`, { keys }, headers());
export const createTopic = body => axios.post(`${base}/topics`, body, headers());
export const updateTopic = (id, body) => axios.put(`${base}/topics/${id}`, body, headers());
export const deleteTopic = id => axios.delete(`${base}/topics/${id}`, headers());

export const listSessions = filters => axios.post(`${base}/sessions/list`, filters, headers());
export const createSession = body => axios.post(`${base}/sessions`, body, headers());
export const getSession = id => axios.get(`${base}/sessions/${id}`, headers());
export const updateSession = (id, body) => axios.put(`${base}/sessions/${id}`, body, headers());
export const deleteSession = id => axios.delete(`${base}/sessions/${id}`, headers());
export const signParticipant = (id, body) =>
  axios.post(`${base}/sessions/${id}/sign`, body, headers());
export const completeSession = (id, body) =>
  axios.post(`${base}/sessions/${id}/complete`, body, headers());
export const deleteSessionAttachment = (id, attachmentId) =>
  axios.delete(`${base}/sessions/${id}/attachments/${attachmentId}`, headers());

const upload = (url, file) => {
  const body = new FormData();
  body.append("file", file, file.name);
  return axios.post(url, body, headers());
};
export const uploadSessionAttachment = (id, file) =>
  upload(`${base}/sessions/${id}/attachments`, file);

export const listQualifications = filters =>
  axios.post(`${base}/qualifications/list`, filters, headers());
export const createQualification = body => axios.post(`${base}/qualifications`, body, headers());
export const updateQualification = (id, body) =>
  axios.put(`${base}/qualifications/${id}`, body, headers());
export const deleteQualification = id => axios.delete(`${base}/qualifications/${id}`, headers());
export const uploadQualificationFile = (id, file) =>
  upload(`${base}/qualifications/${id}/files`, file);

export const listAssessments = filters =>
  axios.post(`${base}/risk-assessments/list`, filters, headers());
export const createAssessment = body => axios.post(`${base}/risk-assessments`, body, headers());
export const getAssessment = id => axios.get(`${base}/risk-assessments/${id}`, headers());
export const updateAssessment = (id, body) =>
  axios.put(`${base}/risk-assessments/${id}`, body, headers());
export const deleteAssessment = id => axios.delete(`${base}/risk-assessments/${id}`, headers());
export const approveAssessment = id =>
  axios.post(`${base}/risk-assessments/${id}/approve`, {}, headers());
export const reviseAssessment = (id, reason) =>
  axios.post(`${base}/risk-assessments/${id}/revise`, { reason }, headers());
export const archiveAssessment = id =>
  axios.post(`${base}/risk-assessments/${id}/archive`, {}, headers());

// Links that open in a new tab cannot send a header: the token goes in the query.
const withToken = url => `${url}?token=${encodeURIComponent(token() || "")}`;
export const sessionPdfUrl = id => withToken(`${base}/sessions/${id}/pdf`);
export const sessionFileUrl = (id, attachmentId) =>
  withToken(`${base}/sessions/${id}/attachments/${attachmentId}`);
export const qualificationFileUrl = (id, attachmentId) =>
  withToken(`${base}/qualifications/${id}/files/${attachmentId}`);
export const assessmentPdfUrl = id => withToken(`${base}/risk-assessments/${id}/pdf`);
